/**
 * IvCert
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';
import { AreaP } from '../model/areaP';
import { CargoP } from '../model/cargoP';
import { IvCertGenericResponseAreaR } from '../model/ivCertGenericResponseAreaR';
import { IvCertGenericResponseBoolean } from '../model/ivCertGenericResponseBoolean';
import { IvCertGenericResponseCargoR } from '../model/ivCertGenericResponseCargoR';
import { IvCertGenericResponseListAreaP } from '../model/ivCertGenericResponseListAreaP';
import { IvCertGenericResponseListAreaR } from '../model/ivCertGenericResponseListAreaR';
import { IvCertGenericResponseListCargoP } from '../model/ivCertGenericResponseListCargoP';
import { IvCertGenericResponseListOrganizationUserL } from '../model/ivCertGenericResponseListOrganizationUserL';
import { IvCertGenericResponseListRoleR } from '../model/ivCertGenericResponseListRoleR';
import { IvCertGenericResponseOrganizationUserR } from '../model/ivCertGenericResponseOrganizationUserR';
import { IvCertGenericResponseRegisterConditions } from '../model/ivCertGenericResponseRegisterConditions';
import { IvCertGenericResponseUserRegisterResponse } from '../model/ivCertGenericResponseUserRegisterResponse';
import { IvCertGenericResponseListIvcertUserProfiles } from '../model/ivCertGenericResponseListIvcertUserProfiles';
import { IvCertGenericResponseListUserAreaData } from '../model/ivCertGenericResponseListUserAreaData';
import { OrganizationUserP } from '../model/organizationUserP';
import { PageResultCargoQ } from '../model/pageResultCargoQ';
import { RegisterCertificateRequest } from '../model/registerCertificateRequest';
import { RegisterConditions } from '../model/registerConditions';
import { UserNoteRequest } from '../model/userNoteRequest';
import { UserRegisterRequest } from '../model/userRegisterRequest';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { DateParser } from "../date";
import { IvCertGenericResponseListArea } from '../model/ivCertGenericResponseListArea';
import { IvCertGenericResponseString } from '../model/ivCertGenericResponseString';
import { IvCertGenericResponseListUserSignatureType } from '../model/ivCertGenericResponseListUserSignatureType';
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { Environment } from '../../models/environment';
import { EnvironmentService } from './environment.service';
import { PageResultOrganizationUserQ } from '../model/pageResultOrganizationUserQ';

@Injectable()
export class UserService {

    environment: Environment;
    protected basePath: string;
    protected apiVersion: string;
    public defaultHeaders = new HttpHeaders().set('timeClient', DateParser.parse(new Date()));
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration, private _personalization: PersonalizationsService, private _env: EnvironmentService) {
        this.environment = this._personalization.sendEnv;
        this.apiVersion = this._env.apiVersion;
        this.basePath = this.environment?.url_api;
        this.defaultHeaders = this.defaultHeaders.set('X-Request-ID', 'app-front');
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * Elimina el área especificada
     *
     * @param idArea
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userDeleteArea(idArea: number, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public userDeleteArea(idArea: number, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public userDeleteArea(idArea: number, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public userDeleteArea(idArea: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idArea === null || idArea === undefined) {
            throw new Error('Required parameter idArea was null or undefined when calling userDeleteArea.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userDeleteArea.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idArea !== undefined && idArea !== null) {
            queryParameters = queryParameters.set('idArea', <any>idArea);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/User/Area`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina el cargo especificado
     *
     * @param idCargo
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userDeleteCargo(idCargo: number, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public userDeleteCargo(idCargo: number, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public userDeleteCargo(idCargo: number, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public userDeleteCargo(idCargo: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idCargo === null || idCargo === undefined) {
            throw new Error('Required parameter idCargo was null or undefined when calling userDeleteCargo.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userDeleteCargo.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCargo !== undefined && idCargo !== null) {
            queryParameters = queryParameters.set('idCargo', <any>idCargo);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/User/Cargo`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete specified user
     *
     * @param username
     * @param Authorization The authorization token
     * @param email User email. This parameter is not mandatory.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userDeleteUser(username: string, Authorization: string, email?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public userDeleteUser(username: string, Authorization: string, email?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public userDeleteUser(username: string, Authorization: string, email?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public userDeleteUser(username: string, Authorization: string, email?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling userDeleteUser.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling userDeleteUser.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (username !== undefined && username !== null) {
            queryParameters = queryParameters.set('username', <any>username);
        }
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', <any>email);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/v2/User/User`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene un área a partir de su identificador
     *
     * @param idArea
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetArea(idArea: number, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseAreaR>;
    public userGetArea(idArea: number, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseAreaR>>;
    public userGetArea(idArea: number, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseAreaR>>;
    public userGetArea(idArea: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idArea === null || idArea === undefined) {
            throw new Error('Required parameter idArea was null or undefined when calling userGetArea.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetArea.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idArea !== undefined && idArea !== null) {
            queryParameters = queryParameters.set('idArea', <any>idArea);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseAreaR>(`${this.basePath}/api/${this.apiVersion}/User/Area`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene un cargo a partir de su identificador
     *
     * @param idCargo
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    async userGetCargo(idCargo: number, authorization: string, observe?: 'body', reportProgress?: boolean): Promise<IvCertGenericResponseCargoR>;
    async userGetCargo(idCargo: number, authorization: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<IvCertGenericResponseCargoR>>;
    async userGetCargo(idCargo: number, authorization: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<IvCertGenericResponseCargoR>>;
    async userGetCargo(idCargo: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Promise<any> {

        if (idCargo === null || idCargo === undefined) {
            throw new Error('Required parameter idCargo was null or undefined when calling userGetCargo.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetCargo.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCargo !== undefined && idCargo !== null) {
            queryParameters = queryParameters.set('idCargo', <any>idCargo);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return await this.httpClient.get<IvCertGenericResponseCargoR>(`${this.basePath}/api/${this.apiVersion}/User/Cargo`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * Obtiene la lista de áreas activas
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetListActiveArea(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListAreaP>;
    public userGetListActiveArea(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListAreaP>>;
    public userGetListActiveArea(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListAreaP>>;
    public userGetListActiveArea(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetListActiveArea.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListAreaP>(`${this.basePath}/api/${this.apiVersion}/User/ListActiveArea`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la lista de cargos activos del área especificada
     *
     * @param idArea
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetListActiveCargoArea(idArea: number, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListCargoP>;
    public userGetListActiveCargoArea(idArea: number, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListCargoP>>;
    public userGetListActiveCargoArea(idArea: number, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListCargoP>>;
    public userGetListActiveCargoArea(idArea: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idArea === null || idArea === undefined) {
            throw new Error('Required parameter idArea was null or undefined when calling userGetListActiveCargoArea.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetListActiveCargoArea.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idArea !== undefined && idArea !== null) {
            queryParameters = queryParameters.set('idArea', <any>idArea);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListCargoP>(`${this.basePath}/api/${this.apiVersion}/User/ListActiveCargoArea`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la lista de cargos activos por áreas de la organización
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetListActiveCargoCompany(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListAreaR>;
    public userGetListActiveCargoCompany(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListAreaR>>;
    public userGetListActiveCargoCompany(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListAreaR>>;
    public userGetListActiveCargoCompany(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetListActiveCargoCompany.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListAreaR>(`${this.basePath}/api/${this.apiVersion}/User/ListActiveCargoCompany`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetListAllAreasOrganization(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListArea>;
    public userGetListAllAreasOrganization(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListArea>>;
    public userGetListAllAreasOrganization(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListArea>>;
    public userGetListAllAreasOrganization(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetListAllAreasOrganization.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListArea>(`${this.basePath}/api/${this.apiVersion}/User/ListAllAreasOrganization`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
     * Obtiene la lista de todas los cargos visibles por el usuario
     *
     * @param authorization The authorization token
     * @param top The max number of records. (e.g. $top&#x3D;10)
     * @param skip The number of records to skip. (e.g. $skip&#x3D;5)
     * @param filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
     * @param select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
     * @param inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
     * @param orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    async userGetListAllCargo(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'body', reportProgress?: boolean): Promise<PageResultCargoQ>;
    async userGetListAllCargo(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<PageResultCargoQ>>;
    async userGetListAllCargo(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<PageResultCargoQ>>;
    async userGetListAllCargo(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe: any = 'body', reportProgress: boolean = false): Promise<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetListAllCargo.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (top !== undefined && top !== null) {
            queryParameters = queryParameters.set('$top', <any>top);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('$skip', <any>skip);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>filter);
        }
        if (select !== undefined && select !== null) {
            queryParameters = queryParameters.set('$select', <any>select);
        }
        if (inlinecount !== undefined && inlinecount !== null) {
            queryParameters = queryParameters.set('$inlinecount', <any>inlinecount);
        }
        if (orderby !== undefined && orderby !== null) {
            queryParameters = queryParameters.set('$orderby', <any>orderby);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return await this.httpClient.get<PageResultCargoQ>(`${this.basePath}/api/${this.apiVersion}/User/ListAllCargo`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
    *
    *
    * @param authorization The authorization token
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public userGetListAreasUser(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListUserAreaData>;
    public userGetListAreasUser(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListUserAreaData>>;
    public userGetListAreasUser(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListUserAreaData>>;
    public userGetListAreasUser(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetListAreasUser.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListUserAreaData>(`${this.basePath}/api/${this.apiVersion}/User/ListAreasUser`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la lista de empleados de una organización
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    async userGetListOrganizationUser(authorization: string, observe?: 'body', reportProgress?: boolean): Promise<IvCertGenericResponseListOrganizationUserL>;
    async userGetListOrganizationUser(authorization: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<IvCertGenericResponseListOrganizationUserL>>;
    async userGetListOrganizationUser(authorization: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<IvCertGenericResponseListOrganizationUserL>>;
    async userGetListOrganizationUser(authorization: string, observe: any = 'body', reportProgress: boolean = false): Promise<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetListOrganizationUser.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return await this.httpClient.get<IvCertGenericResponseListOrganizationUserL>(`${this.basePath}/api/${this.apiVersion}/User/ListOrganizationUser`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * Obtiene la lista de roles
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetListRole(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListRoleR>;
    public userGetListRole(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListRoleR>>;
    public userGetListRole(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListRoleR>>;
    public userGetListRole(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetListRole.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListRoleR>(`${this.basePath}/api/${this.apiVersion}/User/ListRole`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the active register conditions
     *
     * @param typeCondition
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    async userGetRegisterConditions(typeCondition: string, authorization: string, observe?: 'body', reportProgress?: boolean): Promise<IvCertGenericResponseRegisterConditions>;
    async userGetRegisterConditions(typeCondition: string, authorization: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<IvCertGenericResponseRegisterConditions>>;
    async userGetRegisterConditions(typeCondition: string, authorization: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<IvCertGenericResponseRegisterConditions>>;
    async userGetRegisterConditions(typeCondition: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Promise<any> {

        if (typeCondition === null || typeCondition === undefined) {
            throw new Error('Required parameter typeCondition was null or undefined when calling userGetRegisterConditions.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetRegisterConditions.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (typeCondition !== undefined && typeCondition !== null) {
            queryParameters = queryParameters.set('typeCondition', <any>typeCondition);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return await this.httpClient.get<IvCertGenericResponseRegisterConditions>(`${this.basePath}/api/${this.apiVersion}/User/RegisterConditions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     *
     *
     * @param guidUser
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetSignature(guidUser: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseString>;
    public userGetSignature(guidUser: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseString>>;
    public userGetSignature(guidUser: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseString>>;
    public userGetSignature(guidUser: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (guidUser === null || guidUser === undefined) {
            throw new Error('Required parameter guidUser was null or undefined when calling userGetSignature.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetSignature.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (guidUser !== undefined && guidUser !== null) {
            queryParameters = queryParameters.set('guidUser', <any>guidUser);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseString>(`${this.basePath}/api/${this.apiVersion}/User/Signature`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene un usuario a partir de su nif
     *
     * @param username
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetUser(username: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseOrganizationUserR>;
    public userGetUser(username: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseOrganizationUserR>>;
    public userGetUser(username: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseOrganizationUserR>>;
    public userGetUser(username: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling userGetUser.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetUser.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (username !== undefined && username !== null) {
            queryParameters = queryParameters.set('username', <any>username);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseOrganizationUserR>(`${this.basePath}/api/${this.apiVersion}/User/User`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        )
    }

    /**
     *
     *
     * @param idUser
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetUserById(idUser: number, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseOrganizationUserR>;
    public userGetUserById(idUser: number, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseOrganizationUserR>>;
    public userGetUserById(idUser: number, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseOrganizationUserR>>;
    public userGetUserById(idUser: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idUser === null || idUser === undefined) {
            throw new Error('Required parameter idUser was null or undefined when calling userGetUserById.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetUserById.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idUser !== undefined && idUser !== null) {
            queryParameters = queryParameters.set('idUser', <any>idUser);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseOrganizationUserR>(`${this.basePath}/api/${this.apiVersion}/User/UserById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene un usuario depiendo del area
     *
     * @param idArea
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    async userGetUserListArea(idArea: number, authorization: string, observe?: 'body', reportProgress?: boolean): Promise<IvCertGenericResponseListOrganizationUserL>;
    async userGetUserListArea(idArea: number, authorization: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<IvCertGenericResponseListOrganizationUserL>>;
    async userGetUserListArea(idArea: number, authorization: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<IvCertGenericResponseListOrganizationUserL>>;
    async userGetUserListArea(idArea: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Promise<any> {

        if (idArea === null || idArea === undefined) {
            throw new Error('Required parameter idArea was null or undefined when calling userGetUserListArea.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetUserListArea.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idArea !== undefined && idArea !== null) {
            queryParameters = queryParameters.set('idArea', <any>idArea);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return await this.httpClient.get<IvCertGenericResponseListOrganizationUserL>(`${this.basePath}/api/${this.apiVersion}/User/UserListArea`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * Crea un área
     *
     * @param area
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPostArea(area: AreaP, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseAreaR>;
    public userPostArea(area: AreaP, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseAreaR>>;
    public userPostArea(area: AreaP, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseAreaR>>;
    public userPostArea(area: AreaP, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (area === null || area === undefined) {
            throw new Error('Required parameter area was null or undefined when calling userPostArea.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPostArea.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseAreaR>(`${this.basePath}/api/${this.apiVersion}/User/Area`,
            area,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea un nuevo cargo
     *
     * @param cargo
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPostCargo(cargo: CargoP, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseCargoR>;
    public userPostCargo(cargo: CargoP, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseCargoR>>;
    public userPostCargo(cargo: CargoP, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseCargoR>>;
    public userPostCargo(cargo: CargoP, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cargo === null || cargo === undefined) {
            throw new Error('Required parameter cargo was null or undefined when calling userPostCargo.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPostCargo.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseCargoR>(`${this.basePath}/api/${this.apiVersion}/User/Cargo`,
            cargo,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param emailInvitation
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPostCreateInvitation(emailInvitation: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public userPostCreateInvitation(emailInvitation: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public userPostCreateInvitation(emailInvitation: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public userPostCreateInvitation(emailInvitation: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (emailInvitation === null || emailInvitation === undefined) {
            throw new Error('Required parameter emailInvitation was null or undefined when calling userPostCreateInvitation.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPostCreateInvitation.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (emailInvitation !== undefined && emailInvitation !== null) {
            queryParameters = queryParameters.set('emailInvitation', <any>emailInvitation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.post<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/User/CreateInvitation`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea un usuario para la operacion NOTE
     *
     * @param request
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPostCreateUserNote(request: UserNoteRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseOrganizationUserR>;
    public userPostCreateUserNote(request: UserNoteRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseOrganizationUserR>>;
    public userPostCreateUserNote(request: UserNoteRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseOrganizationUserR>>;
    public userPostCreateUserNote(request: UserNoteRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling userPostCreateUserNote.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPostCreateUserNote.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseOrganizationUserR>(`${this.basePath}/api/${this.apiVersion}/User/CreateUserNote`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param request
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPostRegister(request: UserRegisterRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseUserRegisterResponse>;
    public userPostRegister(request: UserRegisterRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseUserRegisterResponse>>;
    public userPostRegister(request: UserRegisterRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseUserRegisterResponse>>;
    public userPostRegister(request: UserRegisterRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling userPostRegister.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPostRegister.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseUserRegisterResponse>(`${this.basePath}/api/${this.apiVersion}/User/Register`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Register user with certificate or without certificate
     *
     * @param request
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPostRegisterCertificate(request: RegisterCertificateRequest, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public userPostRegisterCertificate(request: RegisterCertificateRequest, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public userPostRegisterCertificate(request: RegisterCertificateRequest, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public userPostRegisterCertificate(request: RegisterCertificateRequest, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling userPostRegisterCertificate.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPostRegisterCertificate.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/User/RegisterCertificate`,
            request,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param registerConditions
     * @param idOperation
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    async userPostRegisterConditionsUserAccept(registerConditions: RegisterConditions, idOperation: string, authorization: string, observe?: 'body', reportProgress?: boolean): Promise<IvCertGenericResponseBoolean>;
    async userPostRegisterConditionsUserAccept(registerConditions: RegisterConditions, idOperation: string, authorization: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<IvCertGenericResponseBoolean>>;
    async userPostRegisterConditionsUserAccept(registerConditions: RegisterConditions, idOperation: string, authorization: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<IvCertGenericResponseBoolean>>;
    async userPostRegisterConditionsUserAccept(registerConditions: RegisterConditions, idOperation: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Promise<any> {

        if (registerConditions === null || registerConditions === undefined) {
            throw new Error('Required parameter registerConditions was null or undefined when calling userPostRegisterConditionsUserAccept.');
        }

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling userPostRegisterConditionsUserAccept.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPostRegisterConditionsUserAccept.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return await this.httpClient.post<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/User/RegisterConditionsUserAccep`,
            registerConditions,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * Crea un usuario
     *
     * @param user
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPostUser(user: OrganizationUserP, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseOrganizationUserR>;
    public userPostUser(user: OrganizationUserP, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseOrganizationUserR>>;
    public userPostUser(user: OrganizationUserP, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseOrganizationUserR>>;
    public userPostUser(user: OrganizationUserP, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (user === null || user === undefined) {
            throw new Error('Required parameter user was null or undefined when calling userPostUser.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPostUser.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseOrganizationUserR>(`${this.basePath}/api/${this.apiVersion}/User/User`,
            user,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifica un área
     *
     * @param area
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPutArea(area: AreaP, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseAreaR>;
    public userPutArea(area: AreaP, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseAreaR>>;
    public userPutArea(area: AreaP, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseAreaR>>;
    public userPutArea(area: AreaP, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (area === null || area === undefined) {
            throw new Error('Required parameter area was null or undefined when calling userPutArea.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPutArea.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseAreaR>(`${this.basePath}/api/${this.apiVersion}/User/Area`,
            area,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifica el cargo especificado
     *
     * @param cargo
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPutCargo(cargo: CargoP, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseCargoR>;
    public userPutCargo(cargo: CargoP, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseCargoR>>;
    public userPutCargo(cargo: CargoP, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseCargoR>>;
    public userPutCargo(cargo: CargoP, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cargo === null || cargo === undefined) {
            throw new Error('Required parameter cargo was null or undefined when calling userPutCargo.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPutCargo.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseCargoR>(`${this.basePath}/api/${this.apiVersion}/User/Cargo`,
            cargo,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Change user active language
     *
     * @param newLanguage
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userChangeActiveLanguage(newLanguage: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public userChangeActiveLanguage(newLanguage: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public userChangeActiveLanguage(newLanguage: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public userChangeActiveLanguage(newLanguage: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (newLanguage === null || newLanguage === undefined) {
            throw new Error('Required parameter newLanguage was null or undefined when calling userChangeActiveLanguage.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userChangeActiveLanguage.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (newLanguage !== undefined && newLanguage !== null) {
            queryParameters = queryParameters.set('newLanguage', <any>newLanguage);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.post<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/User/ChangeActiveLanguage`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Habilita/deshabilita el área especificada
     *
     * @param idArea
     * @param enable
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPutEnableArea(idArea: number, enable: boolean, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public userPutEnableArea(idArea: number, enable: boolean, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public userPutEnableArea(idArea: number, enable: boolean, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public userPutEnableArea(idArea: number, enable: boolean, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idArea === null || idArea === undefined) {
            throw new Error('Required parameter idArea was null or undefined when calling userPutEnableArea.');
        }

        if (enable === null || enable === undefined) {
            throw new Error('Required parameter enable was null or undefined when calling userPutEnableArea.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPutEnableArea.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idArea !== undefined && idArea !== null) {
            queryParameters = queryParameters.set('idArea', <any>idArea);
        }
        if (enable !== undefined && enable !== null) {
            queryParameters = queryParameters.set('enable', <any>enable);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/User/EnableArea`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param guidInvitation
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPutResendInvitation(guidInvitation: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public userPutResendInvitation(guidInvitation: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public userPutResendInvitation(guidInvitation: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public userPutResendInvitation(guidInvitation: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (guidInvitation === null || guidInvitation === undefined) {
            throw new Error('Required parameter guidInvitation was null or undefined when calling userPutResendInvitation.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPutResendInvitation.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (guidInvitation !== undefined && guidInvitation !== null) {
            queryParameters = queryParameters.set('guidInvitation', <any>guidInvitation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/User/ResendInvitation`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifica un usuario
     *
     * @param user
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPutUser(user: OrganizationUserP, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseOrganizationUserR>;
    public userPutUser(user: OrganizationUserP, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseOrganizationUserR>>;
    public userPutUser(user: OrganizationUserP, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseOrganizationUserR>>;
    public userPutUser(user: OrganizationUserP, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (user === null || user === undefined) {
            throw new Error('Required parameter user was null or undefined when calling userPutUser.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPutUser.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseOrganizationUserR>(`${this.basePath}/api/${this.apiVersion}/User/User`,
            user,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetProfiles(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListIvcertUserProfiles>;
    public userGetProfiles(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListIvcertUserProfiles>>;
    public userGetProfiles(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListIvcertUserProfiles>>;
    public userGetProfiles(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetProfiles.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListIvcertUserProfiles>(`${this.basePath}/api/${this.apiVersion}/User/GetProfiles`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    *
    *
    * @param userId
    * @param authorization The authorization token
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public userGetUserIvSignById(userId: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseOrganizationUserR>;
    public userGetUserIvSignById(userId: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseOrganizationUserR>>;
    public userGetUserIvSignById(userId: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseOrganizationUserR>>;
    public userGetUserIvSignById(userId: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userGetUserIvSignById.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetUserIvSignById.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (userId !== undefined && userId !== null) {
            queryParameters = queryParameters.set('userId', <any>userId);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseOrganizationUserR>(`${this.basePath}/api/${this.apiVersion}/User/UserIvSignById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param userId
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetCheckUserId(userId: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public userGetCheckUserId(userId: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public userGetCheckUserId(userId: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public userGetCheckUserId(userId: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userGetCheckUserId.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetCheckUserId.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (userId !== undefined && userId !== null) {
            queryParameters = queryParameters.set('userId', <any>userId);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/User/CheckUserId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    *
    *
    * @param guidInvitation
    * @param authorization The authorization token
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public userGetEmailByGuidInvitation(guidInvitation: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userGetEmailByGuidInvitation(guidInvitation: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userGetEmailByGuidInvitation(guidInvitation: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userGetEmailByGuidInvitation(guidInvitation: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (guidInvitation === null || guidInvitation === undefined) {
            throw new Error('Required parameter guidInvitation was null or undefined when calling userGetEmailByGuidInvitation.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetEmailByGuidInvitation.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (guidInvitation !== undefined && guidInvitation !== null) {
            queryParameters = queryParameters.set('guidInvitation', <any>guidInvitation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<any>(`${this.basePath}/api/${this.apiVersion}/User/GetEmailByGuidInvitation`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    *
    *
    * @param guidUser
    * @param authorization The authorization token
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public userGetUserSignaturesByTypeOperation(guidUser: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListUserSignatureType>;
    public userGetUserSignaturesByTypeOperation(guidUser: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListUserSignatureType>>;
    public userGetUserSignaturesByTypeOperation(guidUser: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListUserSignatureType>>;
    public userGetUserSignaturesByTypeOperation(guidUser: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (guidUser === null || guidUser === undefined) {
            throw new Error('Required parameter guidUser was null or undefined when calling userGetUserSignaturesByTypeOperation.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetUserSignaturesByTypeOperation.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (guidUser !== undefined && guidUser !== null) {
            queryParameters = queryParameters.set('guidUser', <any>guidUser);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListUserSignatureType>(`${this.basePath}/api/${this.apiVersion}/User/UserSignaturesByTypeOperation`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idFolder
     * @param idSubFolder
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPutLevelFolder(idFolder: number, idSubFolder: number, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userPutLevelFolder(idFolder: number, idSubFolder: number, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userPutLevelFolder(idFolder: number, idSubFolder: number, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userPutLevelFolder(idFolder: number, idSubFolder: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idFolder === null || idFolder === undefined) {
            throw new Error('Required parameter idFolder was null or undefined when calling userPutLevelFolder.');
        }

        if (idSubFolder === null || idSubFolder === undefined) {
            throw new Error('Required parameter idSubFolder was null or undefined when calling userPutLevelFolder.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userPutLevelFolder.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idFolder !== undefined && idFolder !== null) {
            queryParameters = queryParameters.set('IdFolder', <any>idFolder);
        }
        if (idSubFolder !== undefined && idSubFolder !== null) {
            queryParameters = queryParameters.set('IdSubFolder', <any>idSubFolder);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<any>(`${this.basePath}/api/${this.apiVersion}/User/LevelFolder`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param name
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPutFolderName(id: number, name: string, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public userPutFolderName(id: number, name: string, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public userPutFolderName(id: number, name: string, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public userPutFolderName(id: number, name: string, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userPutFolderName.');
        }

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling userPutFolderName.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling userPutFolderName.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/User/FolderName`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the list of users visible to the user
     *
     * @param Authorization The authorization token
     * @param top The max number of records. (e.g. $top&#x3D;10)
     * @param skip The number of records to skip. (e.g. $skip&#x3D;5)
     * @param filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
     * @param select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
     * @param inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
     * @param orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetListAllUser(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'body', reportProgress?: boolean): Observable<PageResultOrganizationUserQ>;
    public userGetListAllUser(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageResultOrganizationUserQ>>;
    public userGetListAllUser(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageResultOrganizationUserQ>>;
    public userGetListAllUser(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling userGetListAllUser.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (top !== undefined && top !== null) {
            queryParameters = queryParameters.set('$top', <any>top);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('$skip', <any>skip);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>filter);
        }
        if (select !== undefined && select !== null) {
            queryParameters = queryParameters.set('$select', <any>select);
        }
        if (inlinecount !== undefined && inlinecount !== null) {
            queryParameters = queryParameters.set('$inlinecount', <any>inlinecount);
        }
        if (orderby !== undefined && orderby !== null) {
            queryParameters = queryParameters.set('$orderby', <any>orderby);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PageResultOrganizationUserQ>(`${this.basePath}/api/v2/User/ListAllUser`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetUserProfile(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseString>;
    public userGetUserProfile(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseString>>;
    public userGetUserProfile(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseString>>;
    public userGetUserProfile(authorization: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetUserProfile.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<IvCertGenericResponseString>(`${this.basePath}/api/v2/User/UserProfile`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
